import { makeStyles } from '@material-ui/core'

export default makeStyles((theme) => ({
  gridContainer: {
    marginTop: '80px',
    display: 'flex',
    alignItems: 'center',
    [theme.breakpoints.down('xs')]: {
      marginTop: '50px',
    },
  },
  fab: {
    position: 'fixed',
    bottom: theme.spacing(4),
    right: theme.spacing(6),
  },
  extendedIcon: {
    marginRight: theme.spacing(1),
  },
}))
